<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt />
      </a>
      <!-- <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt />
      </a> -->
    </div>
    <div class="box"></div>
    <div class="title-bj">
      <div class="title">{{detail.title}}</div>
      <div class="priceBox">
        <span
          class="span"
        >会议时间：{{startTime.slice(0,startTime.length - 8)}}~ {{endTime.slice(0,endTime.length - 8)}}</span>
        <span class="span">地点：{{detail.region}}</span>
      </div>
    </div>
    <div class="success">
      <img src="../assets/img/icon_Successz.png" alt>
      <span>报名成功！</span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      name: '',
      detail: '',
      startTime: '',
      endTime: '',
    }
  },
  created () {
    this.content()
  },
  methods: {
    content () {
      this.$axios
        .post(`api/web/phone/content/detail/${this.$route.query.contentId}`, {})
        .then(res => {
          this.detail = res.data
          this.endTime = res.data.endTime
          this.startTime = res.data.startTime

          // setTimeout(function() {

          // }, 3000);
        })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: #9f9f9f;
  margin: 20px 24px;
  text-align: left;
}
.priceBox {
  position: relative;
}
.TicketPrice {
  position: absolute;
  font-size: 12px;
  top: 0;
  right: 0;
}
.title-bj {
  padding: 26px;
  margin: 22px 12px;
  min-height: 68px;
  background: url("../assets/img/dingdan_bg@3x.png");
  background-size: 100% 100%;
}
.span {
  text-align: left;
  font-size: 12px;
  display: block;
  margin-top: 8px;
}
.title {
  text-align: left;
  font-weight: 700;
  // padding: 26px 26px 0 26px;
  font-size: 16px;
}
.success {
  margin-top: 20%;
  img {
    width: 20%;
  }
  span {
    display: block;
    padding: 32px;
    font-weight: bold;
  }
}

/* 使用webkit内核的浏览器 */
::-webkit-input-placeholder {
  color: #9f9f9f;
  line-height: normal;
  padding-top: 0.06rem;
}
/* Firefox版本4-18 */
:-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}
/* Firefox版本19+ */
::-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}
/* IE浏览器 */
:-ms-input-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}
.p {
  margin: 9px 10px 0;
  font-size: 12px;
}
.box {
  height: 56px;
}
.body {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;
  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;
    img{
      height: 35px;
    }
  }
  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/singupSuccess.vue